import { Processing } from 'flows/common/steps/BrandKitForm/Processing'
import { MediaType } from 'components/Wizards/schemas/shared/mediaType'

interface LoadingStateProps {
  mediaType?: MediaType
}

const LOADING_STEPS = {
  base: [
    { name: 'Generating text', minDuration: 0.15, maxDuration: 0.3 },
    { name: 'Applying Brand Kit', minDuration: 0.12, maxDuration: 0.22 },
  ],
  media: {
    [MediaType.DocumentWithImages]: { name: 'Selecting images', minDuration: 0.14, maxDuration: 0.23 },
    [MediaType.Design]: { name: 'Selecting templates', minDuration: 0.13, maxDuration: 0.24 },
  } as Record<MediaType, { name: string; minDuration: number; maxDuration: number } | undefined>,
  final: { name: 'Scheduling', minDuration: 0.15, maxDuration: 0.26 },
}

export const LoadingState = ({ mediaType = MediaType.DocumentWithImages }: LoadingStateProps) => {
  const mediaStep = LOADING_STEPS.media[mediaType]
  const steps = [...LOADING_STEPS.base, ...(mediaStep ? [mediaStep] : []), LOADING_STEPS.final]

  return <Processing steps={steps} />
}
